export const programSiteCoreKeys = {
  generalHeader: "createProgram.generalHeader",
  keyProgramDetails: "KeyProgramDetails",
  client: "KeyProgramDetails.Client",
  alternateDisplayName: "KeyProgramDetails.AlternateDisplayName",
  opportunityID: "KeyProgramDetails.OpportunityID",
  opportunityName: "KeyProgramDetails.OpportunityName",
  opportunityIDAssociatedWithAnotherClient:
    "KeyProgramDetails.OpportunityIDAssociatedWithAnotherClient",
  opportunityIDAssociatedWithAnotherContract:
    "KeyProgramDetails.OpportunityIDAssociatedWithAnotherContract",
  opportunityIDAssociatedWithProgramMessage:
    "KeyProgramDetails.OpportunityIDAssociatedWithProgramMessage",
  opportunityIDMustBeValidatedMessage:
    "KeyProgramDetails.OpportunityIDMustBeValidatedMessage",
  opportunityIDInvalidMessage: "KeyProgramDetails.OpportunityIDInvalidMessage",
  deliveryCountry: "KeyProgramDetails.DeliveryCountry",
  productLine: "KeyProgramDetails.ProductLine",
  programTemplate: "KeyProgramDetails.ProgramTemplate",
  salesOffice: "KeyProgramDetails.SalesOffice",
  programCreatedMessage: "KeyProgramDetails.ProgramCreatedMessage",
  programLoaderMessage: "KeyProgramDetails.ProgramLoaderMessage",
  programCreateSuccessMessage: "KeyProgramDetails.ProgramCreateSuccessMessage",
  tagAProjectCheckBox: "KeyProgramDetails.TagAProjectCheckBox",
  projectKey: "KeyProgramDetails.ProjectKey",
  projectName: "KeyProgramDetails.ProjectName",
  otherLabel: "KeyProgramDetails.Other",
  billingConfiguration: "KeyProgramDetails.BillingConfiguration",
  noProgramTemplateFoundMessage:
    "KeyProgramDetails.NoProgramTemplateFoundMessage",
  noProgramTemplateAvailable: "KeyProgramDetails.NoProgramTemplateAvailable",
  youHaventFinishedCreatingTheProgramYet:
    "KeyProgramDetails.YouHaventFinishedCreatingTheProgramYet",
  movingOnToAnotherPageConfirmationMessage:
    "KeyProgramDetails.MovingOnToAnotherPageConfirmationMessage",

  generalDetails: "GeneralDetails",
  programKey: "GeneralDetails.ProgramKey",
  generalClient: "GeneralDetails.Client",
  generalOpportunityID: "GeneralDetails.OpportunityID",
  generalOpportunityName: "GeneralDetails.OpportunityName",
  generalAlternateDisplayName: "GeneralDetails.AlternateDisplayName",
  generalDeliveryCountry: "GeneralDetails.DeliveryCountry",
  generalKeyProgramDetails: "GeneralDetails.KeyProgramDetails",
  generalProductLine: "GeneralDetails.ProductLine",
  generalProgramStatus: "GeneralDetails.ProgramStatus",
  generalProgramTemplate: "GeneralDetails.ProgramTemplate",
  generalRegistrationCode: "GeneralDetails.RegistrationCode",
  generalRegistrationDetails: "GeneralDetails.RegistrationDetails",
  generalRegistrationEmailID: "GeneralDetails.RegistrationEmailID",
  generalRegistrationStatus: "GeneralDetails.RegistrationStatus",
  generalSalesOffice: "GeneralDetails.SalesOffice",
  nextPersona: "KeyProgramDetails.NextPersona",
  registrationDetails: "GeneralDetails.RegistrationDetails",
  statusList: "GeneralDetails.StatusList",
  generalProjectKey: "GeneralDetails.ProjectKey",
  generalProjectName: "GeneralDetails.ProjectName",

  modifyKeyProgramDetails: "KeyProgramDetails.ModifyKeyProgramDetails",
  programUpdatingWaitMessage: "KeyProgramDetails.ProgramUpdatingWaitMessage",
  programUpdatedSuccessMessage:
    "KeyProgramDetails.ProgramUpdatedSuccessMessage",
  areYouSureYouWantToModifyTheKeyProgramDetails:
    "KeyProgramDetails.AreYouSureYouWantToModifyTheKeyProgramDetails",

  //tabs
  participant: "KeyProgramDetails.Participant",
  program: "KeyProgramDetails.Program",
  //program details
  programDetails: "ProgramDetails",
  programName: "ProgramDetails.ProgramName",
  solutionOffering: "ProgramDetails.SolutionOffering",
  programClass: "ProgramDetails.ProgramClass",
  businessUnit: "ProgramDetails.BusinessUnit",
  clientInformation1: "ProgramDetails.ClientInformation1",
  clientInformation2: "ProgramDetails.ClientInformation2",
  clientInformation3: "ProgramDetails.ClientInformation3",
  pONumber: "ProgramDetails.PONumber",
  dossierNumber: "ProgramDetails.DossierNumber",
  actualClient: "ProgramDetails.ActualClient",
  nextView: "ProgramDetails.NextView",
  nextProgramClass: "ProgramDetails.NextProgramClass",
  costCenter: "ProgramDetails.CostCenter",
  site: "ProgramDetails.Site",
  programStatus: "ProgramStatus",
  currentStatus: "ProgramStatus.CurrentStatus",
  programStatusList: "ProgramStatus.StatusList",
  savingProgramAlertText: "KeyProgramDetails.SavingProgramAlertText",
  saveProgramSuccessText: "KeyProgramDetails.SaveProgramSuccessText",
  programDetailsPrefix: "ProgramDetails.Prefix",
  participantFirstName: "ProgramDetails.ParticipantFirstName",
  participantLastName: "ProgramDetails.ParticipantLastName",
  programDetailsPrefixList: "ProgramDetails.PrefixList",
  //change status
  programStatusKey: "ProgramStatus",
  changeStatusPopupHeader: "ProgramStatus.ChangeStatusLink",
  changeProgramStatus: "ProgramStatus.Status",
  fromDate: "CreateProgramComponent.ChangeStatusModelPopup.FromDate",
  throughDate: "CreateProgramComponent.ChangeStatusModelPopup.ThroughDate",
  programClosureToastMessage:
    "CreateProgramComponent.ChangeStatusModelPopup.ProgramClosureToastMessage",
  overlappingPeriodsSavingErrorMessage:
    "CreateProgramComponent.ChangeStatusModelPopup.OverlappingPeriodsSavingErrorMessage",
  programReOpenPromptMessage:
    "CreateProgramComponent.ChangeStatusModelPopup.ProgramReOpenPromptMessage",
  createdDate: "ProgramStatus.Created-ModifiedDate",
  inActiveThroughDate: "ProgramStatus.InactiveThroughDate",
  notes: "ProgramStatus.Notes",
  programStatusPopupStatusList:
    "CreateProgramComponent.ChangeStatusModelPopup.StatusList",
  programStatusCreatedModifiedDate: "ProgramStatus.Created-ModifiedBy",
  programStatusInactiveFromDate: "ProgramStatus.InactiveFromDate",
  programStatusFromDate: "ProgramStatus.FromDate",
  programStatusThroughDate: "ProgramStatus.ThroughDate",

  createdName: "ProgramStatus.Created-ModifiedBy",
  viewProgramStatusList: "ProgramStatus.StatusList",
  editInactivityPopupHeader:
    "CreateProgramComponent.ChangeStatusModelPopup.EditInactivityPopupHeader",
  action: "ProgramStatus.Action",
  programStatusUpdatedMessage:
    "CreateProgramComponent.ChangeStatusModelPopup.ProgramStatusUpdatedMessage",
  throughDateValidationMessage:
    "CreateProgramComponent.ChangeStatusModelPopup.ThroughDateValidationMessage",
  updatingInactivityMessage:
    "CreateProgramComponent.ChangeStatusModelPopup.ProgramStatusUpdatedMessage",
  updatingProgramStatusMessage:
    "CreateProgramComponent.ChangeStatusModelPopup.UpdatingProgramStatusMessage",
  inactivityUpdatedMessage:
    "CreateProgramComponent.ChangeStatusModelPopup.InactivityUpdatedMessage",
  primaryClosingReasonList:
    "ChangeStatusPopup.ClosureInformation.PrimaryClosingReasonList",
  secondaryClosingReasonList:
    "ChangeStatusPopup.ClosureInformation.SecondaryClosingReasonList",
  projectedProgramEndDateLabel:
    "CreateProgramComponent.ChangeStatusModelPopup.ProjectedProgramEndDate",
  notesIsRequired: "LandedInformation.General.NotesIsRequired",
  editStatusHeader:
    "CreateProgramComponent.ChangeStatusModelPopup.EditStatusHeader",
  programReOpenedNoteMessage:
    "CreateProgramComponent.ChangeStatusModelPopup.ProgramReOpenedNoteMessage",

  //program closure
  changeStatusModelPopupKey:
    "ProgramsAndCandidates.CreateProgramComponent.ChangeStatusModelPopup",
  closedBy: "ChangeStatusPopup.ClosureInformation.ClosedBy",
  closedDate: "ChangeStatusPopup.ClosureInformation.ClosedDate",
  landedDate: "LandedInformation.General.LandedDate",
  landedInformationPostalCode: "LandedInformation.General.PostalCode",
  closureInformationHeader:
    "CreateProgramComponent.ChangeStatusModelPopup.ClosureInformationHeader",
  compensationComparison:
    "LandedInformation.EmployerInformation.CompansationComparision",
  contractType: "LandedInformation.EmployerInformation.ContractType",
  employerInformationTab:
    "ChangeStatusPopup.LandedInformation.EmployerInformationTab",
  functionalChange: "LandedInformation.EmployerInformation.FunctionalChange",
  general: "ChangeStatusPopup.LandedInformation.General",
  geographicMove: "LandedInformation.General.GeographicMove",
  industryChange: "LandedInformation.EmployerInformation.IndustryChange",
  industryChangeYes: "IndustryChange.Yes",
  industryList: "LandedInformation.EmployerInformation.IndustryList",
  landedInformationHeader:
    "CreateProgramComponent.ChangeStatusModelPopup.LandedInformationHeader",
  viewStatusDetailsHeader:
    "CreateProgramComponent.ChangeStatusModelPopup.ViewStatusDetailsHeader",
  programCloseConfirmationMessage:
    "CreateProgramComponent.ChangeStatusModelPopup.ProgramCloseConfirmationMessage",
  landingCountry: "LandedInformation.General.LandingCountry",
  newEmployerName: "LandedInformation.EmployerInformation.NewEmployerName",
  newJobStartDate: "LandedInformation.EmployerInformation.NewJobStartDate",
  dateOfEndOfTrialPeriod:
    "LandedInformation.EmployerInformation.DateOfEndOfTrialPeriod",
  solutionValidationDate:
    "LandedInformation.EmployerInformation.SolutionValidationDate",
  solutionValidationDateErrorMessage:
    "LandedInformation.EmployerInformation.SolutionValidationDateErrorMessage",
  newEmploymentContractType:
    "LandedInformation.EmployerInformation.NewEmploymentContractType",
  newEmploymentContractTypeListPrefix:
    "LandedInformation.EmployerInformation.NewEmploymentContractTypeList",
  newOccupationalFunction:
    "LandedInformation.EmployerInformation.NewOccupationalFunction",
  newOccupationalFunctionListPrefix:
    "LandedInformation.EmployerInformation.NewOccupationalFunctionList",
  functionalChangeYes: "FunctionalChange.Yes",
  newOccupationalFunctionOther:
    "LandedInformation.EmployerInformation.NewOccupationalFunction-Other",
  newTitle: "LandedInformation.EmployerInformation.NewTitle",
  notesGeneral: "LandedInformation.General.Notes",
  occupationalLevelChangeStatus:
    "LandedInformation.EmployerInformation.OccupationalLevel",
  placementMethod: "LandedInformation.EmployerInformation.PlacementMethod",
  currentSalaryRange:
    "LandedInformation.EmployerInformation.CurrentSalaryRange",
  currentSalaryRangeListPrefix:
    "LandedInformation.EmployerInformation.CurrentSalaryRangeList",
  newSalaryRange: "LandedInformation.EmployerInformation.NewSalaryRange",
  newSalaryRangeListPrefix:
    "LandedInformation.EmployerInformation.NewSalaryRangeList",
  newEmployerVATNumber:
    "LandedInformation.EmployerInformation.NewEmployerVATNumber",
  newLevel: "LandedInformation.EmployerInformation.NewLevel",
  newLevelListPrefix: "LandedInformation.EmployerInformation.NewLevelList",
  primaryClosingReason:
    "ChangeStatusPopup.ClosureInformation.PrimaryClosingReason",
  secondaryClosingReason:
    "ChangeStatusPopup.ClosureInformation.SecondaryClosingReason",
  stateProvinceRegion: "LandedInformation.General.StateProvinceRegion",
  landingStateRegionProvinceListPrefix:
    "LandedInformation.General.StateRegionProvinceList",
  status: "CreateProgramComponent.ChangeStatusModelPopup.Status",
  timeToLand: "LandedInformation.General.TimeToLand",
  totalHours: "LandedInformation.General.TotalHours",
  totalNumberOfMeetings: "LandedInformation.General.TotalNumberOfMeetings",
  compensationComparisonList:
    "LandedInformation.EmployerInformation.CompensationComparisonList",
  geographicMoveList: "LandedInformation.General.GeographicMoveList",
  industryChangeList:
    "LandedInformation.EmployerInformation.IndustryChangeList",
  industryListChangeStatus:
    "LandedInformation.EmployerInformation.IndustryList",
  placementMethodList:
    "LandedInformation.EmployerInformation.PlacementMethodList",
  workLocationType: "LandedInformation.EmployerInformation.WorkLocationType",
  workLocationTypeList:
    "LandedInformation.EmployerInformation.WorkLocationTypeList",
  statusListChangeStatus:
    "CreateProgramComponent.ChangeStatusModelPopup.StatusList",
  employerOccupationalLevelList:
    "LandedInformation.EmployerInformation.EmployerOccupationalLevelList",
  functionalChangeList:
    "LandedInformation.EmployerInformation.FunctionalChangeList",
  activityTypeCareerCoachMeetingKey: "ActivityType.CareerCoachMeeting",

  // candidate information
  participantInformation:
    "ProgramsAndCandidates.CreateProgramComponent.ParticipantInformation",
  prefix: "CreateProgramComponent.ParticipantInformation.Prefix",
  prefixList: "CreateProgramComponent.ParticipantInformation.PrefixList",
  firstName: "CreateProgramComponent.ParticipantInformation.FirstName",
  lastName: "CreateProgramComponent.ParticipantInformation.LastName",
  dateOfBirth: "CreateProgramComponent.ParticipantInformation.DateofBirth",
  gender: "CreateProgramComponent.ParticipantInformation.Gender",
  preferredLanguage:
    "CreateProgramComponent.ParticipantInformation.NextLanguage",
  preferredName: "CreateProgramComponent.ParticipantInformation.PreferredName",
  age: "CreateProgramComponent.ParticipantInformation.Age",
  telephone: "CreateProgramComponent.ParticipantInformation.Telephone",
  mobile: "CreateProgramComponent.ParticipantInformation.Mobile",
  appendPhone: "CreateProgramComponent.ParticipantInformation.AppendPhone",
  email: "CreateProgramComponent.ParticipantInformation.EMail",
  workEMail: "CreateProgramComponent.ParticipantInformation.WorkEMail",
  spousePartner: "CreateProgramComponent.ParticipantInformation.SpousePartner",
  educationLevel:
    "CreateProgramComponent.ParticipantInformation.EducationLevel",
  mustStartByDate:
    "CreateProgramComponent.ParticipantInformation.MustStartByDate",
  actualStartDate:
    "CreateProgramComponent.ParticipantInformation.ActualStartDate",
  projectedProgramEndDate:
    "CreateProgramComponent.ParticipantInformation.ProjectedProgramEndDate",
  textSubscribedDate:
    "CreateProgramComponent.ParticipantInformation.TextSubscribedDate",
  textUnsubscribedDate:
    "CreateProgramComponent.ParticipantInformation.TextUnsubscribedDate",
  programEndDateValidationMessage:
    "CreateProgramComponent.ParticipantInformation.ProgramEndDateValidationMessage",
  unsubscribedDateValidationMessage:
    "CreateProgramComponent.ParticipantInformation.UnsubscribedDateValidationMessage",
  emailUnsubscribedDate:
    "CreateProgramComponent.ParticipantInformation.EmailUnsubscribedDate",
  primaryLanguage:
    "CreateProgramComponent.ParticipantInformation.DeliveryLanguage",
  nisId: "CreateProgramComponent.ParticipantInformation.NISID",
  genderList: "CreateProgramComponent.ParticipantInformation.GenderList",
  languageList: "CreateProgramComponent.ParticipantInformation.LanguagesList",
  educationLevelList:
    "CreateProgramComponent.ParticipantInformation.EducationLevelList",
  participantName:
    "CreateProgramComponent.ParticipantInformation.ParticipantName",
  tPSBlacklistStatus:
    "CreateProgramComponent.ParticipantInformation.TPSBlacklistStatus",
  ageRange: "CreateProgramComponent.ParticipantInformation.AgeRange",
  personalId: "CreateProgramComponent.ParticipantInformation.PersonalID",
  personalIdValidationMessage:
    "CreateProgramComponent.ParticipantInformation.PersonalIDValidationMessage",
  personalIdPlaceholderText:
    "CreateProgramComponent.ParticipantInformation.PersonalIDPlaceholderText",

  ageRangeList:
    "CreateProgramComponent.ParticipantInformation.AgeRangeList-Common",
  educationLevelListPrefix:
    "CreateProgramComponent.ParticipantInformation.EducationLevelList",

  batchTypeList: "CreateProgramComponent.ParticipantInformation.BatchTypeList",
  batchType:
    "CreateProgramComponent.ParticipantInformation.BatchTypeDropdownLabel",
  waveCohortDetails:
    "CreateProgramComponent.ParticipantInformation.Wave-CohortDetails",

  //other detail
  officeDetailsKey:
    "ProgramsAndCandidates.CreateProgramComponent.OfficeDetails",
  billingContact: "CreateProgramComponent.OtherDetails.BillingContact",
  billingOffice: "CreateProgramComponent.OtherDetails.BillingOffice",
  deliveryOffice: "CreateProgramComponent.OtherDetails.DeliveryOffice",
  hrContact: "CreateProgramComponent.OtherDetails.HRContact",
  relationshipOwner:
    "CreateProgramComponent.OtherDetails.LocalClientRelationshipOwner",
  projectCoordinator: "CreateProgramComponent.OtherDetails.ProjectCoordinator",
  projectManager: "CreateProgramComponent.OtherDetails.ProjectManager",
  salesOfficeDetail: "CreateProgramComponent.OtherDetails.SalesOffice",
  additionalInvoiceContact:
    "CreateProgramComponent.OtherDetails.AdditionalInvoiceContact",
  participantsManager:
    "CreateProgramComponent.OtherDetails.ParticipantsManager",
  businessApprovalNumber:
    "CreateProgramComponent.OtherDetails.BusinessApprovalNumber",
  additionalHrContact:
    "CreateProgramComponent.OtherDetails.AdditionalHRContactDropdown",
  deliveryLead:
    "CreateProgramComponent.OtherDetails.DeliveryLead-EngagementManagerDropdown",
  hiringManager: "CreateProgramComponent.OtherDetails.HiringManager",
  //billing
  billingInvoiceKey:
    "ProgramsAndCandidates.CreateProgramComponent.BillingInvoice",
  // address details
  addressDetails: "ProgramsAndCandidates.CreateProgramComponent.AddressDetails",
  addressDetailsAddress1: "CreateProgramComponent.AddressDetails.Address1",
  addressDetailsAddress2: "CreateProgramComponent.AddressDetails.Address2",
  addressDetailsAddress3: "CreateProgramComponent.AddressDetails.Address3",
  addressDetailsCity: "CreateProgramComponent.AddressDetails.City",
  addressDetailsCountry: "CreateProgramComponent.AddressDetails.Country",
  addressDetailsPostalCode: "CreateProgramComponent.AddressDetails.PostalCode",
  addressDetailsStateProvince:
    "CreateProgramComponent.AddressDetails.StateProvince",
  stateRegionProvinceListPrefix:
    "CreateProgramComponent.AddressDetails.StateRegionProvinceList",
  postalCodeFormatErrorMessage:
    "CreateProgramComponent.AddressDetails.PostalCodeFormatErrorMessage",

  // outreach
  outreach: "ProgramsAndCandidates.CreateProgramComponent.Outreach",
  aboutParticipant:
    "ProgramsAndCandidates.CreateProgramComponent.AboutParticipant",
  assignedOutreachConsultant:
    "CreateProgramComponent.Outreach.AssignedOutreachConsultant",
  contactWithin24Hours: "CreateProgramComponent.Outreach.ContactWithin24Hours",
  eligibility: "CreateProgramComponent.Outreach.Eligibility",
  notificationDate: "CreateProgramComponent.Outreach.NotificationDate",
  notificationSupportDate:
    "CreateProgramComponent.Outreach.NotificationSupportDate",
  notificationSupportStatus:
    "CreateProgramComponent.Outreach.NotificationSupportStatus",
  outreachEligibleDate: "CreateProgramComponent.Outreach.OutreachEligibleDate",
  clientManaged: "OutreachEligibility.ClientManaged",
  outreachEligible: "OutreachEligibility.OutreachEligible",
  outreachEligibleStatus:
    "CreateProgramComponent.Outreach.OutreachEligibleStatus",
  primaryManagedStatus: "CreateProgramComponent.PrimaryManagedStatus",
  releaseDate: "CreateProgramComponent.Outreach.ReleaseDate",
  secondaryManagedStatus: "CreateProgramComponent.SecondaryManagedStatus",
  eligibilityList: "CreateProgramComponent.Outreach.EligibilityList",
  outreahEligibleStatusList:
    "CreateProgramComponent.Outreach.OutreahEligibleStatusList",
  notificationSupportStatusList:
    "CreateProgramComponent.Outreach.NotificationSupportStatusList",
  primaryManagedStatusList:
    "CreateProgramComponent.Outreach.PrimaryManagedStatusList",
  noOutreachPermittedList:
    "CreateProgramComponent.Outreach.NoOutreachPermittedList",
  pendingFurtherActionsList:
    "CreateProgramComponent.Outreach.PendingFurtherActionsList",
  pendingOREList: "CreateProgramComponent.Outreach.PendingOREList",
  notificationDateOutreachEligibleDateValidationMessage:
    "CreateProgramComponent.Outreach.NotificationDateOutreachEligibleDateValidationMessage",
  // Sponsoring Employer
  sponsoringEmployer:
    "ProgramsAndCandidates.CreateProgramComponent.SponsoringEmployer",
  companyName: "CreateProgramComponent.SponsoringEmployer.CompanyName",
  clientName: "CreateProgramComponent.SponsoringEmployer.ClientName",
  jobTitle: "CreateProgramComponent.SponsoringEmployer.JobTitle",
  employeeId: "CreateProgramComponent.SponsoringEmployer.EmployeeID",
  employeeBand: "CreateProgramComponent.SponsoringEmployer.EmployeeBand",
  totalYearsEmployed:
    "CreateProgramComponent.SponsoringEmployer.TotalYearsEmployed",
  occupationalFunction:
    "CreateProgramComponent.SponsoringEmployer.OccupationalFunction",
  occupationalFunctionOther:
    "CreateProgramComponent.SponsoringEmployer.OccupationalFunctionOther",
  occupationalLevel:
    "CreateProgramComponent.SponsoringEmployer.OccupationalLevel",
  occupationalLevelOther:
    "CreateProgramComponent.SponsoringEmployer.OccupationalLevelOther",
  occupationalFunctionList:
    "CreateProgramComponent.SponsoringEmployer.OccupationalFunctionList",
  occupationalLevelList:
    "CreateProgramComponent.SponsoringEmployer.OccupationalLevelList",
  sponsoringEmployerNotificationDate:
    "CreateProgramComponent.SponsoringEmployer.NotificationDate",
  planPostedDate: "CreateProgramComponent.SponsoringEmployer.PlanPostedDate",
  datePlanApproved:
    "CreateProgramComponent.SponsoringEmployer.DatePlanApproved",
  currentEmploymentStartDate:
    "CreateProgramComponent.SponsoringEmployer.CurrentEmploymentStartDate",
  targetIndustry: "CreateProgramComponent.SponsoringEmployer.TargetIndustry",
  bestMatchPreference:
    "CreateProgramComponent.SponsoringEmployer.BestMatchPreference",
  specialAssignments:
    "CreateProgramComponent.SponsoringEmployer.SpecialAssignments",
  participantGroupType:
    "CreateProgramComponent.SponsoringEmployer.ParticipantGroupType",
  socialFundList: "CreateProgramComponent.SponsoringEmployer.SocialFundList",
  socialFund: "CreateProgramComponent.SponsoringEmployer.SocialFund",
  participantGroupTypeList:
    "CreateProgramComponent.SponsoringEmployer.ParticipantGroupTypeList",
  candidateSaveSuccessText:
    "CreateProgramComponent.ParticipantInformation.CandidateSaveSuccessText",
  candidateSaveWaitText:
    "CreateProgramComponent.ParticipantInformation.CandidateSaveWaitText",
  viewProgramTitle:
    "ProgramsAndCandidates.CreateProgramComponent.ViewProgramHeader",
  editProgramTitle:
    "ProgramsAndCandidates.CreateProgramComponent.EditProgramHeader",
  address: "CreateProgramComponent.AddressDetails.Address",
  createProgramHeader: "CreateProgramHeader",
  viewInvoiceHistoryButton:
    "ProgramsAndCandidates.CreateProgramComponent.ViewInvoiceHistoryButton",
  bestMatchPreferenceList:
    "CreateProgramComponent.SponsoringEmployer.BestMatchPreferenceList",
  specialAssignmentsList:
    "CreateProgramComponent.SponsoringEmployer.SpecialAssignmentsList",
  candidateUpdateWaitText:
    "CreateProgramComponent.ParticipantInformation.CandidateUpdateWaitText",
  candidateUpdateSuccessText:
    "CreateProgramComponent.ParticipantInformation.CandidateUpdateSuccessText",
  employeeIDValidationMessage:
    "CreateProgramComponent.SponsoringEmployer.EmployeeIDValidationMessage",

  // Intake / Selection
  intakeSelection:
    "ProgramsAndCandidates.CreateProgramComponent.IntakeSelection",
  bioStatusSection: "CreateProgramComponent.IntakeSelection.BioStatusSection",
  biosSent: "IntakeSelection.BioStatusSection.BiosSent",
  bioStatus: "IntakeSelection.BioStatusSection.BioStatus",
  chemistryMeetingSection:
    "CreateProgramComponent.IntakeSelection.ChemistryMeetingSection",
  chemistryMeetingSelected:
    "IntakeSelection.ChemistryMeetingSection.ChemistryMeetingSelected",
  chemistryMeetingStatus:
    "IntakeSelection.ChemistryMeetingSection.ChemistryMeetingStatus",
  coachSelected: "IntakeSelection.ChemistryMeetingSection.CoachSelected",
  intakeSection: "CreateProgramComponent.IntakeSelection.IntakeSection",
  biosDeclined: "CreateProgramComponent.IntakeSection.BiosDeclined",
  coachBiosRequested: "CreateProgramComponent.IntakeSection.CoachBiosRequested",
  intakeStatus: "CreateProgramComponent.IntakeSelection.IntakeStatus",
  intakeStatusList: "CreateProgramComponent.IntakeSelection.IntakeStatusList",
  bioStatusList: "CreateProgramComponent.IntakeSelection.BioStatusList",
  chemistryMeetingStatusList:
    "CreateProgramComponent.IntakeSelection.ChemistryMeetingStatusList",

  // career goals
  careerGoal: "ProgramsAndCandidates.CreateProgramComponent.CareerGoals",
  authorisedConnections:
    "CreateProgramComponent.CareerGoals.AuthorisedConnections",
  experis: "CreateProgramComponent.CareerGoals.Experis",
  jeffersonWells: "CreateProgramComponent.CareerGoals.JeffersonWells",
  manPowerEngineering: "CreateProgramComponent.CareerGoals.ManpowerEngineering",
  openToRelocation: "CreateProgramComponent.CareerGoals.OpenToRelocation",
  participantNotSeekingEmployment:
    "CreateProgramComponent.CareerGoals.ParticipantNotSeekingEmployment",
  participantWillingToWorkRemotely:
    "CreateProgramComponent.CareerGoals.ParticipantWillingToWorkRemotely",
  participantWillingToTravelForWork:
    "CreateProgramComponent.CareerGoals.ParticipantWillingToTravelForWork",
  preferences: "CreateProgramComponent.CareerGoals.Preferences",
  rpo: "CreateProgramComponent.CareerGoals.RPO",
  selectAuthorisedConnections:
    "CreateProgramComponent.CareerGoals.SelectAuthorisedConnections",
  selectPreferences: "CreateProgramComponent.CareerGoals.SelectPreferences",
  skillsKeywords: "CreateProgramComponent.CareerGoals.SkillsKeywords",
  targetIndustryCareerGoal: "CreateProgramComponent.CareerGoals.TargetIndustry",
  targetJobTitle: "CreateProgramComponent.CareerGoals.TargetJobTitle",
  targetLocation: "CreateProgramComponent.CareerGoals.TargetLocation",
  targetOccupationalFunction:
    "CreateProgramComponent.CareerGoals.TargetOccupationalFunction",
  targetOccupationalFunctionOther:
    "CreateProgramComponent.CareerGoals.TargetOccupationalFunction-Others",
  targetOccupationalLevel:
    "CreateProgramComponent.CareerGoals.TargetOccupationalLevel",
  targetOrganization: "CreateProgramComponent.CareerGoals.TargetOrganization",
  targetSalaryRange: "CreateProgramComponent.CareerGoals.TargetSalaryRange",
  technicalSkills: "CreateProgramComponent.CareerGoals.TechnicalSkills",
  participantReadyToStartJobSearch:
    "CreateProgramComponent.CareerGoals.ParticipantReadyToStartJobSearch",
  participantJobSearchStartDate:
    "CreateProgramComponent.CareerGoals.ParticipantJobSearchStartDate",
  participantStartJobSearchList:
    "CreateProgramComponent.CareerGoals.ParticipantStartJobSearchList",
  participantStartJobSearchYes: "ParticipantStartJobSearch.Yes",
  participantStartJobSearchNo: "ParticipantStartJobSearch.No",
  jobTypeList: "CreateProgramComponent.CareerGoals.JobTypeList",
  occupationalFunctionListCareerGoal:
    "CreateProgramComponent.CareerGoals.OccupationalFunctionList",
  occupationalLevelListCareerGoal:
    "CreateProgramComponent.CareerGoals.OccupationalLevelList",
  salaryRangeList: "CreateProgramComponent.CareerGoals.SalaryRangeList",
  jobType: "CreateProgramComponent.CareerGoals.TargetJobType",
  popUpInfo:
    "CreateProgramComponent.CareerGoals.AuthorisedConnections-PopupInformation",
  transferParticipantTitle:
    "ProgramsAndCandidates.TransferParticipant.TransferParticipantPopup",
  transferConfirmationnText:
    "CreateProgramComponent.CompleteTransferProcessPopup.ParticipantTransferConfirmationText",
  transferProcessPopup:
    "ProgramsAndCandidates.CreateProgramComponent.CompleteTransferProcessPopup",
  transferSucessText:
    "CreateProgramComponent.CompleteTransferProcessPopup.ParticipantTransferSucessText",
  versionCreatedMessage:
    "CreateProgramComponent.CompleteTransferProcessPopup.VersionCreatedMessage",
  yesProceedButton:
    "CreateProgramComponent.CompleteTransferProcessPopup.Yes-ProceedButton",

  // Program Fee
  programFeeTitle: "ProgramsAndCandidates.CreateProgramComponent.ProgramFee",
  feeDetailsSectionHeading: "ProgramFee.FeeDetailsSectionHeading",
  billingType: "ProgramFee.FeeDetails.BillingType",
  currency: "ProgramFee.FeeDetails.Currency",
  programFee: "ProgramFee.FeeDetails.ProgramFee",
  earlyPayDays: "ProgramFee.FeeDetails.EarlyPayDays",
  earlyPayPercentage: "ProgramFee.FeeDetails.EarlyPayPercentage",
  minimumTransferFee: "ProgramFee.FeeDetails.MinimumTransferFee",
  proBonoCategory: "ProgramFee.FeeDetails.ProBonoCategory",
  billingTypeList: "ProgramFee.FeeDetails.BillingTypeList",
  proBonoCategoryList: "ProgramFee.FeeDetails.ProBonoCategoryList",
  billingTrigger: "ProgramFee.FeeDetails.BillingTrigger",
  billingTriggerList: "ProgramFee.FeeDetails.BillingTriggerList",
  earlyPayPercentageToolTipMessage:
    "ProgramFee.FeeDetails.EarlyPayPercentageToolTipMessage",
  areYouSureYouWantToChangeTheBillingType:
    "ProgramFee.FeeDetails.AreYouSureYouWantToChangeTheBillingType",
  areYouSureYouWantToChangeTheProgramFee:
    "ProgramFee.FeeDetails.AreYouSureYouWantToChangeTheProgramFee",
  programFeeCurrencyHasToBeSameAsPOCurrency:
    "ProgramFee.FeeDetails.ProgramFeeCurrencyHasToBeSameAsPOCurrency",
  minimumTransferFeeShouldBeLessThanProgramFee:
    "ProgramFee.FeeDetails.MinimumTransferFeeShouldBeLessThanProgramFee",
  programFeeShouldBeGreaterThanMinimumTransferFee:
    "ProgramFee.FeeDetails.ProgramFeeShouldBeGreaterThanMinimumTransferFee",
  programUpdatedMessage: "ProgramFee.FeeDetails.ProgramUpdatedMessage",
  viewProgramFeeHeader: "ProgramFee.ViewProgramFeeHeader",
  specialBillingInstructions:
    "ProgramFee.FeeDetails.SpecialBillingInstructions",

  //contact and notification
  contactAndNotificationPreferences:
    "ProgramsAndCandidates.CreateProgramComponent.ContactAndNotificationPreferences",
  nextNotificationPreferencesSection:
    "CreateProgramComponent.ContactAndNotificationPreferences.NextNotificationPreferencesSection",
  smsNotificationsCheckBox:
    "ContactAndNotificationPreferences.NextNotificationPreferences.Text-SMSNotificationsCheckBox",
  sendSmsNotificationsTo:
    "ContactAndNotificationPreferences.NextNotificationPreferences.SendText-SMSNotificationsTo",
  emailNotificationsCheckBox:
    "ContactAndNotificationPreferences.NextNotificationPreferences.EmailNotificationsCheckBox",
  sendEmailNotificationsTo:
    "ContactAndNotificationPreferences.NextNotificationPreferences.SendEmailNotificationsTo",
  additionalParticipantContactDetailsSection:
    "CreateProgramComponent.ContactAndNotificationPreferences.AdditionalParticipantContactDetailsSection",
  emailSubSection:
    "ContactAndNotificationPreferences.AdditionalParticipantContactDetails.EmailSubSection",
  emailIDType1: "AdditionalParticipantContactDetails.Email.EmailIDType1",
  primaryEmailID: "AdditionalParticipantContactDetails.Email.PrimaryEmailID",
  emailIDType2: "AdditionalParticipantContactDetails.Email.EmailIDType2",
  alternateEmailID:
    "AdditionalParticipantContactDetails.Email.AlternateEmailID",
  phoneSubSection:
    "ContactAndNotificationPreferences.AdditionalParticipantContactDetails.PhoneSubSection",
  contactType1: "AdditionalParticipantContactDetails.Phone.ContactType1",
  primaryPhoneNumber:
    "AdditionalParticipantContactDetails.Phone.PrimaryPhoneNumber",
  contactType2: "AdditionalParticipantContactDetails.Phone.ContactType2",
  alternatePhoneNumber:
    "AdditionalParticipantContactDetails.Phone.AlternatePhoneNumber",
  appendedPhoneNumber:
    "AdditionalParticipantContactDetails.Phone.AppendedPhoneNumber",
  emailIDTypeList:
    "CreateProgramComponent.ContactAndNotificationPreferences.EmailIDTypeList",
  phoneCotactTypeList:
    "CreateProgramComponent.ContactAndNotificationPreferences.PhoneCotactTypeList",
  emailIDAlreadyExistsMessage:
    "ContactAndNotificationPreferences.AdditionalParticipantContactDetails.EmailIDAlreadyExistsMessage",
  phoneNumberAlreadyExistsMessage:
    "ContactAndNotificationPreferences.AdditionalParticipantContactDetails.PhoneNumberAlreadyExistsMessage",
  selectedPreferences:
    "ContactAndNotificationPreferences.NextNotificationPreferences.SelectedPreferences",
  textSMSPreferenceOption:
    "ContactAndNotificationPreferences.NextNotificationPreferences.Text-SMSPreferenceOption",
  emailPreferenceOption:
    "ContactAndNotificationPreferences.NextNotificationPreferences.EmailPreferenceOption",
  textSMSNotifications:
    "ContactAndNotificationPreferences.NextNotificationPreferences.Text-SMSNotifications",
  emailNotifications:
    "ContactAndNotificationPreferences.NextNotificationPreferences.EmailNotifications",
  notOpted:
    "ContactAndNotificationPreferences.NextNotificationPreferences.NotOpted",
};

export const activityTimelineSiteCoreKeys = {
  // activity timeline
  activityTimeline:
    "ProgramsAndCandidates.ParticipantActivity.ActivityTimeline",
  activityType: "ParticipantActivity.ActivityTimeline.ActivityType",
  chooseParticipantDropDownLabel:
    "ParticipantActivity.ActivityTimeline.ChooseParticipantDropDown",
  participantSelectionIsRequiredErrorMessage:
    "ParticipantActivity.ActivityTimeline.ParticipantSelectionIsRequiredErrorMessage",
  modality: "ParticipantActivity.ActivityTimeline.Modality",
  topic: "ParticipantActivity.ActivityTimeline.Topic",
  primaryClosingReason:
    "ParticipantActivity.ActivityTimeline.PrimaryClosingReason",
  secondaryClosingReason:
    "ParticipantActivity.ActivityTimeline.SecondaryClosingReason",
  notesLabel: "ParticipantActivity.ActivityTimeline.Notes",
  defaultDuration: "ParticipantActivity.ActivityTimeline.DefaultDuration",
  actualDuration: "ParticipantActivity.ActivityTimeline.ActualDuration",
  defaultDurationMinutes:
    "ParticipantActivity.ActivityTimeline.DefaultDurationMinutes",
  actualDurationMinutes:
    "ParticipantActivity.ActivityTimeline.ActualDurationMinutes",
  onBehalfOfCoachId: "ParticipantActivity.ActivityTimeline.OnBehalfOf",
  actualDurationMinutesList:
    "ParticipantActivity.ActivityTimeline.ActualDurationMinutesList",
  addActivityHeader: "ParticipantActivity.ActivityTimeline.AddActivityHeader",
  activityTypeList: "ParticipantActivity.ActivityTimeline.ActivityTypeList",
  modalityList: "ParticipantActivity.ActivityTimeline.ModalityList",
  activityAddedSuccessText:
    "ParticipantActivity.ActivityTimeline.ActivityAddedSuccessText",
  changesDiscardedText:
    "ParticipantActivity.ActivityTimeline.ChangesDiscardedText",
  closeConfirmationText:
    "ParticipantActivity.ActivityTimeline.CloseConfirmationText",
  filterByCategory: "ParticipantActivity.ActivityTimeline.FilterByCategory",
  show: "ParticipantActivity.ActivityTimeline.Show",
  addActivityLink: "ParticipantActivity.ActivityTimeline.AddActivityLink",
  byLabel: "ParticipantActivity.ActivityTimeline.By",
  noActivitiesAvailableText:
    "ParticipantActivity.ActivityTimeline.NoActivitiesAvailableText",
  showFilterList: "ParticipantActivity.ActivityTimeline.ShowFilterList",
  deleteActivityConfirmationText:
    "ParticipantActivity.ActivityTimeline.DeleteActivityConfirmationText",
  activityUpdatedSuccessText:
    "ParticipantActivity.ActivityTimeline.ActivityUpdatedSuccessText",
  editActivityHeader: "ParticipantActivity.ActivityTimeline.EditActivity",
  addActivityParticipantNamePopupHeader:
    "ParticipantActivity.ActivityTimeline.AddActivityParticipantNamePopupHeader",
  cancelConfirmationText:
    "ParticipantActivity.ActivityTimeline.CancelConfirmationText",
  fromDateLabel: "ParticipantActivity.ActivityTimeline.FromDate",
  toDateLabel: "ParticipantActivity.ActivityTimeline.ToDate",
  bulkActivityListHeader:
    "ParticipantActivity.ActivityTimeline.BulkActivityListHeader",
  addActivitysProceedMessage:
    "ParticipantActivity.ActivityTimeline.AddActivitysProceedMessage",
  actionHeader: "ParticipantActivity.ActivityTimeline.Action",
  duplicateActivityErrorMessage:
    "ParticipantActivity.ActivityTimeline.DuplicateActivityErrorMessage",
  compatibleProgramTemplate:
    "ParticipantActivity.ActivityTimeline.CompatibleProgramTemplate",
  createdBy: "ParticipantActivity.ActivityTimeline.CreatedBy",
  nextView: "ParticipantActivity.ActivityTimeline.NextView",
  participantTransferred:
    "ParticipantActivity.ActivityTimeline.ParticipantTransferred",
  mobilityToOutplacement:
    "ParticipantActivity.ActivityTimeline.MobilityToOutplacement",
  transferredCountry:
    "ParticipantActivity.ActivityTimeline.TransferredToCountry",
  bulkActivityCancelConfirmationText:
    "ParticipantActivity.ActivityTimeline.BulkActivityCancelConfirmationText",
  BulkActivityUpdatedToastMessage:
    "ParticipantActivity.ActivityTimeline.BulkActivityUpdatedToastMessage",
  activityDeletedToastMessage:
    "ParticipantActivity.ActivityTimeline.ActivityDeletedToastMessage",
  activityDate: "ParticipantActivity.ActivityTimeline.ActivityDate",
  nextContactDate: "ParticipantActivity.ActivityTimeline.NextContactDate",
  modifyNextContactDatePopupHeader:
    "ParticipantActivity.ActivityTimeline.ModifyNEXTContactDatePopupHeader",
  nextContactDateUpdatedMessage:
    "ParticipantActivity.ActivityTimeline.NextContactDateUpdatedMessage",
  nextContactDateMustBeTodayOrAFutureDate:
    "ParticipantActivity.ActivityTimeline.NextContactDateMustBeTodayOrAFutureDate",
  intakeStatusList: "ParticipantActivity.ActivityTimeline.IntakeStatusList",
  bioStatusList: "ParticipantActivity.ActivityTimeline.BioStatusList",
  chemistryMeetingStatusList:
    "ParticipantActivity.ActivityTimeline.ChemistryMeetingStatusList",
  intakeStatusTitle: "ParticipantActivity.ActivityTimeline.IntakeStatusTitle",
  bioStatusTitle: "ParticipantActivity.ActivityTimeline.BioStatusTitle",
  chemistryMeetingStatusTitle:
    "ParticipantActivity.ActivityTimeline.ChemistryMeetingStatusTitle",
  coachSelectedTitle: "ParticipantActivity.ActivityTimeline.CoachSelected",
  convertedToP3: "ParticipantActivity.ActivityTimeline.ConvertedToP3",
  nisStatus: "ParticipantActivity.ActivityTimeline.NISStatus",
  nisConvertedDate: "ParticipantActivity.ActivityTimeline.NISConvertedDate",
  nisConvertedBy: "ParticipantActivity.ActivityTimeline.NISConvertedBy",
  programKey: "ParticipantActivity.ActivityTimeline.ProgramKey",
  nisParticipantStatusList:
    "ParticipantActivity.ActivityTimeline.NISParticipantStatusList",
};

export const feesAndExpensesSiteCoreKeys = {
  feesAndExpenses:
    "ProgramsAndCandidates.CreateProgramComponent.FeesAndExpenses",
  addFeesAndExpenses: "FeesAndExpenses.BillingItem.AddFeesExpensesButton",
  billingItemsSection: "FeesAndExpenses.BillingItemSectionHeading",
  addBillingItemBtn: "FeesAndExpenses.BillingItem.AddFeesExpensesButton",
  feeExpenseName: "FeesAndExpenses.BillingItem.FeeExpenseName",
  transactionDate: "FeesAndExpenses.BillingItem.TransactionDate",
  itemType: "FeesAndExpenses.BillingItem.Type",
  itemCategory: "FeesAndExpenses.BillingItem.Category",
  feeExpenseType: "FeesAndExpenses.BillingItem.FeeExpenseType",
  itemStatus: "FeesAndExpenses.BillingItem.Status",
  itemStatusList: "FeesAndExpenses.BillingItem.StatusList",
  unitRate: "FeesAndExpenses.BillingItem.UnitRate",
  quantity: "FeesAndExpenses.BillingItem.Quantity",
  amount: "FeesAndExpenses.BillingItem.FeeOrExpenseAmount",
  billingAmount: "FeesAndExpenses.BillingItem.BillingAmount",
  taxAmount: "FeesAndExpenses.BillingItem.TaxAmount",
  totalBillingAmount: "FeesAndExpenses.BillingItem.TotalBillingAmount",
  itemAction: "FeesAndExpenses.BillingItem.Action",
  comments: "FeesAndExpenses.BillingItem.Comments",
  noDataMessage: "FeesAndExpenses.BillingItem.FeesExpensesNotFoundMessage",
  raiseInvoiceBtn: "FeesAndExpenses.BillingItem.RaiseInvoiceButton",
  invoiceAmount: "FeesAndExpenses.BillingItem.InvoiceAmount",
  deleteFeesAndExpenseContentText:
    "FeesAndExpenses.BillingItem.AreYouSureYouwantToDeleteTheFeeOrExpense",
  dossierNumberActualClientNotAvailableMessage:
    "FeesAndExpenses.BillingItem.DossierNumberActualClientNotAvailableMessage",
};

export const addFeesAndExpensesSiteCoreKeys = {
  addFeesAndExpenses:
    "ProgramsAndCandidates.CreateProgramComponent.AddFeesAndExpenses",
  editFeesAndExpensesHeading: "AddFeesAndExpenses.EditFeesAndExpensesHeading", // "Edit - #FEEOREXPENSENAME# [#TYPE#]",
  viewFeesAndExpensesHeading: "AddFeesAndExpenses.ViewFeesAndExpensesHeading", // "View - #FEEOREXPENSENAME# [#TYPE#]",
  selectTypeHeading: "AddFeesAndExpenses.SelectTypeHeading",
  typeHeading: "AddFeesAndExpenses.TypeHeading",
  changeTypeConfirmation: "AddFeesAndExpenses.AreYouSureYouWantToChangeTheType",
  programProjectFeeRadioButton:
    "AddFeesAndExpenses.AdditionalProgramOrProjectFee",
  expenseRadioButton: "AddFeesAndExpenses.Expense",
  programFeeType: "AddFeesAndExpenses.ProgramFee",
  programOrProjectFeeType: "AddFeesAndExpenses.ProgramOrProjectFee",
  generalTab: "AddFeesAndExpenses.GeneralTab",
  taxTab: "AddFeesAndExpenses.TaxTab",
  summaryTab: "AddFeesAndExpenses.SummaryTab",
  feeName: "AddFeesAndExpenses.GeneralTab.FeeName",
  expenseName: "AddFeesAndExpenses.GeneralTab.ExpenseName",
  transactionDate: "AddFeesAndExpenses.GeneralTab.TransactionDate",
  incurredBy: "AddFeesAndExpenses.GeneralTab.IncurredBy",
  feeDetailsHeading: "AddFeesAndExpenses.GeneralTab.FeeDetailsHeading",
  feeDetailsType: "AddFeesAndExpenses.GeneralTab.FeeDetailsHeading.FeeType",
  feeDetailsCurrency:
    "AddFeesAndExpenses.GeneralTab.FeeDetailsHeading.FeeCurrency",
  feeDetailsAmount: "AddFeesAndExpenses.GeneralTab.FeeDetailsHeading.FeeAmount",
  expenseDetailsHeading: "AddFeesAndExpenses.GeneralTab.ExpenseDetailsHeading",
  expenseDetailsCategory:
    "AddFeesAndExpenses.GeneralTab.ExpenseDetailsHeading.Category",
  expenseDetailsType:
    "AddFeesAndExpenses.GeneralTab.ExpenseDetailsHeading.ExpenseType",
  expenseDetailsUnitPrice:
    "AddFeesAndExpenses.GeneralTab.ExpenseDetailsHeading.UnitPrice",
  expenseDetailsQuantity:
    "AddFeesAndExpenses.GeneralTab.ExpenseDetailsHeading.Quantity",
  expenseDetailsCurrency:
    "AddFeesAndExpenses.GeneralTab.ExpenseDetailsHeading.ExpenseCurrency",
  expenseDetailsAmount:
    "AddFeesAndExpenses.GeneralTab.ExpenseDetailsHeading.ExpenseAmount",
  billingDetailsHeading: "AddFeesAndExpenses.GeneralTab.BillingDetailsHeading",
  billingDetailsCurrency:
    "AddFeesAndExpenses.GeneralTab.BillingDetailsHeading.BillingCurrency",
  billingDetailsExchangeRate:
    "AddFeesAndExpenses.GeneralTab.BillingDetailsHeading.ExchangeRate",
  billingDetailsTooltipMessage:
    "AddFeesAndExpenses.GeneralTab.BillingDetailsHeading.ExchangeRateTooltipMessage",
  billingDetailsConvert:
    "AddFeesAndExpenses.GeneralTab.BillingDetailsHeading.Convert",
  billingDetailsExchangeRateError:
    "AddFeesAndExpenses.GeneralTab.BillingDetailsHeading.ConvertExchangeRateToProceedErrorMessage",
  billingDetailsAmount:
    "AddFeesAndExpenses.GeneralTab.BillingDetailsHeading.BillingAmount",
  billingDetailsAmountTooltip:
    "AddFeesAndExpenses.GeneralTab.BillingDetailsHeading.BillingAmountTooltipMessage",
  summaryTabFeeName: "AddFeesAndExpenses.SummaryTab.FeeNameTableColumn",
  summaryTabFeeAmount: "AddFeesAndExpenses.SummaryTab.FeeAmountTableColumn",
  summaryTabExpenseAmount:
    "AddFeesAndExpenses.SummaryTab.ExpenseAmountTableColumn",
  summaryTabExchangeRate:
    "AddFeesAndExpenses.SummaryTab.ExchangeRateTableColumn",
  summaryTabBillingAmount:
    "AddFeesAndExpenses.SummaryTab.BillingAmountTableColumn",
  summaryTabTax: "AddFeesAndExpenses.SummaryTab.TaxTableColumn",
  summaryTabTotalInvoiceAmount:
    "AddFeesAndExpenses.SummaryTab.TotalInvoiceAmountTableColumn",
  feeTypeList: "AddFeesAndExpenses.FeeTypeList",
  cancelConfirmMessage:
    "AddFeesAndExpenses.AreYouSureYouWantToDiscardTheChanges",
  typeChangeConfirmation: "AddFeesAndExpenses.AreYouSureYouWantToChangeTheType",
  exchangeRateError:
    "AddFeesAndExpenses.GeneralTab.BillingDetailsHeading.ConvertExchangeRateToProceedErrorMessage",
  editHeading: "AddFeesAndExpenses.EditFeesAndExpensesHeading",
  summaryTabAmount: "AddFeesAndExpenses.ViewFeesAndExpenses.Summary.Amount",
  summaryTabTotalTaxAmount:
    "AddFeesAndExpenses.ViewFeesAndExpenses.Summary.TotalTaxAmount",
  summaryTabTotalBillingAmount:
    "AddFeesAndExpenses.ViewFeesAndExpenses.Summary.TotalBillingAmount",
};
export const raiseInvoiceSiteCoreKeys = {
  raiseInvoiceTitle:
    "ProgramsAndCandidates.CreateProgramComponent.FeesAndExpenses.RaiseInvoice",
  downloadProformaInvoiceLinkText:
    "FeesAndExpenses.RaiseInvoice.DownloadProformaInvoiceLinkText",
  summarySectionHeader: "FeesAndExpenses.RaiseInvoice.SummarySectionHeader",
  summaryTotalAmount: "FeesAndExpenses.RaiseInvoice.Summary.TotalAmount",
  summaryTotalTaxAmount: "FeesAndExpenses.RaiseInvoice.Summary.TotalTaxAmount",
  summaryTotalInvoiceAmount:
    "FeesAndExpenses.RaiseInvoice.Summary.TotalInvoiceAmount",
  feeAndExpensesSectionHeader:
    "FeesAndExpenses.RaiseInvoice.FeeAndExpensesSectionHeader",
  invoiceLineNumberTableColumn:
    "FeesAndExpenses.RaiseInvoice.FeeAndExpenses.InvoiceLineNumberTableColumn",
  feeOrExpenseNameTableColumn:
    "FeesAndExpenses.RaiseInvoice.FeeAndExpenses.FeeOrExpenseNameTableColumn",
  typeTableColumn:
    "FeesAndExpenses.RaiseInvoice.FeeAndExpenses.TypeTableColumn",
  categoryTableColumn:
    "FeesAndExpenses.RaiseInvoice.FeeAndExpenses.CategoryTableColumn",
  feeOrExpenseTypeTableColumn:
    "FeesAndExpenses.RaiseInvoice.FeeAndExpenses.FeeOrExpenseTypeTableColumn",
  billingAmountTableColumn:
    "FeesAndExpenses.RaiseInvoice.FeeAndExpenses.BillingAmountTableColumn",
  taxAmountTableColumn:
    "FeesAndExpenses.RaiseInvoice.FeeAndExpenses.TaxAmountTableColumn",
  totalInvoiceAmountTableColumn:
    "FeesAndExpenses.RaiseInvoice.FeeAndExpenses.TotalInvoiceAmountTableColumn",
  invoiceAndPODetailsSectionHeader:
    "FeesAndExpenses.RaiseInvoice.InvoiceAndPODetailsSectionHeader",
  poNumber: "FeesAndExpenses.RaiseInvoice.InvoiceAndPODetails.PONumber",
  currentPOBalance:
    "FeesAndExpenses.RaiseInvoice.InvoiceAndPODetails.CurrentPOBalance",
  poShortage: "FeesAndExpenses.RaiseInvoice.InvoiceAndPODetails.POShortage",
  poShortageMessage:
    "FeesAndExpenses.RaiseInvoice.InvoiceAndPODetails.YouHaveAPOShortagePleaseAddANewPOTopUpExistingPO",
  invoiceButton: "FeesAndExpenses.RaiseInvoice.InvoiceButton",
  areYouSureYouWantToRaiseTheInvoice:
    "FeesAndExpenses.RaiseInvoice.AreYouSureYouWantToRaiseTheInvoice",
  successPopupHeader: "FeesAndExpenses.RaiseInvoice.SuccessPopupHeader",
  successPopupDescriptionText:
    "FeesAndExpenses.RaiseInvoice.SuccessPopupDescriptionText",
  viewInvoiceHistoryLinkText:
    "FeesAndExpenses.RaiseInvoice.SuccessPopup.ViewInvoiceHistoryLinkText",
  invoiceDate: "FeesAndExpenses.RaiseInvoice.InvoiceAndPODetails.InvoiceDate",
  paymentTermsDropDown:
    "FeesAndExpenses.RaiseInvoice.InvoiceAndPODetails.PaymentTermsDropDown",
  invoiceHistoryPaymentTerms: "InvoiceHistory.ViewInvoice.Summary.PaymentTerms",
  invoiceHistoryInvoiceDate: "InvoiceHistory.ViewInvoice.Summary.InvoiceDate",
  invoiceDateMustBeWithinTheAccountingPeriod:
    "FeesAndExpenses.RaiseInvoice.InvoiceDateMustBeWithinTheAccountingPeriod",
  invoiceLanguage:
    "FeesAndExpenses.RaiseInvoice.InvoiceAndPODetails.InvoiceLanguage",
  invoiceLanguageList:
    "FeesAndExpenses.RaiseInvoice.InvoiceAndPODetails.InvoiceLanguageList",
  localInvoiceNumber:
    "FeesAndExpenses.RaiseInvoice.InvoiceAndPODetails.LocalInvoiceNumber",
  poNoAmountMessage:
    "FeesAndExpenses.RaiseInvoice.InvoiceAndPODetails.YouHaveAPOWithoutBalanceMessage",
};

export const invoiceHistorySiteCoreKeys = {
  invoiceHistoryTitle:
    "ProgramsAndCandidates.CreateProgramComponent.InvoiceHistory",
  totalInvoicedAmountAsOfToday: "InvoiceHistory.TotalInvoicedAmountAsOfToday",
  invoiceNumberTableColumn: "InvoiceHistory.InvoiceNumberTableColumn",
  invoicedDateTableColumn: "InvoiceHistory.InvoiceOrReversalDateTableColumn",
  invoiceStatusTableColumn: "InvoiceHistory.InvoiceStatusTableColumn",
  totalInvoiceAmountTableColumn: "InvoiceHistory.TotalInvoiceAmountTableColumn",
  issuedByTableColumn: "InvoiceHistory.IssuedByTableColumn",
  poNumberTableColumn: "InvoiceHistory.PONumberTableColumn",
  actionTableColumn: "InvoiceHistory.ActionTableColumn",
  reverseInvoice: "InvoiceHistory.Action.Reverse",
  areYouSureYouWantToReverseTheInvoice:
    "InvoiceHistory.ConfirmationPopUp.AreYouSureYouWantToReverseTheInvoice",
  invoiceReversed: "InvoiceHistory.InvoiceReversedMessage",
  viewInvoiceHeader: "InvoiceHistory.ViewInvoicePopupHeader",
  viewReversedInvoiceHeader: "InvoiceHistory.ViewReversedInvoicePopupHeader",
  summarySectionHeader: "InvoiceHistory.ViewInvoice.SummarySectionHeader",
  summaryTotalAmount: "InvoiceHistory.ViewInvoice.Summary.TotalAmount",
  summaryTotalTaxAmount: "InvoiceHistory.ViewInvoice.Summary.TotalTaxAmount",
  summaryTotalInvoiceAmount:
    "InvoiceHistory.ViewInvoice.Summary.TotalInvoiceAmount",
  summaryUtilizedPO: "InvoiceHistory.ViewInvoice.Summary.UtilizedPO",
  summaryInvoicedStatus: "InvoiceHistory.ViewInvoice.Summary.InvoicedStatus",
  summaryPaymentTerms: "InvoiceHistory.ViewInvoice.Summary.PaymentTerms",
  summaryInvoiceDate: "InvoiceHistory.ViewInvoice.Summary.InvoiceDate",
  summaryReversedDate: "InvoiceHistory.ViewInvoice.Summary.ReversalDate",
  viewCommentLink: "InvoiceHistory.ViewInvoice.Summary.ViewCommentLink",
  feeAndExpensesSectionHeader:
    "InvoiceHistory.ViewInvoice.FeeAndExpensesSectionHeader",
  feeOrExpenseNameTableColumn:
    "InvoiceHistory.ViewInvoice.FeeAndExpenses.FeeOrExpenseNameTableColumn",
  transactionDateTableColumn:
    "InvoiceHistory.ViewInvoice.FeeAndExpenses.TransactionDateTableColumn",
  typeTableColumnView:
    "InvoiceHistory.ViewInvoice.FeeAndExpenses.TypeTableColumn",
  categoryTableColumnView:
    "InvoiceHistory.ViewInvoice.FeeAndExpenses.CategoryTableColumn",
  feeOrExpenseTypeTableColumnView:
    "InvoiceHistory.ViewInvoice.FeeAndExpenses.FeeOrExpenseTypeTableColumn",
  billingAmountTableColumnView:
    "InvoiceHistory.ViewInvoice.FeeAndExpenses.BillingAmountTableColumn",
  taxAmountTableColumnView:
    "InvoiceHistory.ViewInvoice.FeeAndExpenses.TaxAmountTableColumn",
  totalBillingAmountTableColumn:
    "InvoiceHistory.ViewInvoice.FeeAndExpenses.TotalBillingAmountTableColumn",
  programFeeType: "InvoiceHistory.ViewInvoice.FeeAndExpenses.ProgramFee",
  invoiceStatusList: "InvoiceHistory.InvoiceStatusList",
  billingItemTypeList: "InvoiceHistory.ViewInvoice.BillingItemTypeList",
  statusInvoiced: "Status.Invoiced",
  statusReversed: "Status.Reversed",
  invoiceLineNumberTableColumn:
    "InvoiceHistory.ViewInvoice.FeeAndExpenses.InvoiceLineNumberTableColumn",
  confirmationPopUpReversalReasonDropDown:
    "InvoiceHistory.ConfirmationPopUp.ReversalReasonDropDown",
  confirmationPopUpReversalDate:
    "InvoiceHistory.ConfirmationPopUp.ReversalDate",
  confirmationPopUpCommentOther:
    "InvoiceHistory.ConfirmationPopUp.CommentOther",
  confirmationPopUpCommentBoxPlaceholderText:
    "InvoiceHistory.ConfirmationPopUp.CommentBoxPlaceholderText",
  confirmationPopUpInvoiceReversalReasonList:
    "InvoiceHistory.ConfirmationPopUp.InvoiceReversalReasonList",
  reversalReasonTableColumn: "InvoiceHistory.ReversalReasonTableColumn",
  summaryInvoiceLanguage: "InvoiceHistory.ViewInvoice.Summary.InvoiceLanguage",
  summaryReversalReason: "InvoiceHistory.ViewInvoice.Summary.ReversalReason",
  summaryReversalComment: "InvoiceHistory.ViewInvoice.Summary.ReversalComment",
  summaryLocalInvoiceNumber:
    "InvoiceHistory.ViewInvoice.Summary.LocalInvoiceNumber",
  manageRevenueSplitAction: "InvoiceHistory.Action.ManageRevenueSplit",
  viewRevenueSplitAction: "InvoiceHistory.Action.ViewRevenueSplit",
};

export const manageRevenueSplitSiteCoreKeys = {
  manageRevenueSplit: "Common.ManageRevenueSplit",
  relationshipType: "ManageRevenueSplit.RelationshipType",
  accountingPeriod: "ManageRevenueSplit.AccountingPeriod",
  corporateOffice: "ManageRevenueSplit.CorporateOffice",
  salesOffice: "ManageRevenueSplit.SalesOffice",
  deliveryOffice: "ManageRevenueSplit.DeliveryOffice",
  salesSplit: "ManageRevenueSplit.SalesSplit",
  programFee: "ManageRevenueSplit.ProgramFee",
  projectFee: "ManageRevenueSplit.ProjectFee",
  projectKey: "ManageRevenueSplit.ProjectKey",
  projectName: "ManageRevenueSplit.ProjectName",
  minimumTransferFee: "ManageRevenueSplit.MinimumTransferFee",
  revenueSplitSectionHeader: "ManageRevenueSplit.RevenueSplitSectionHeader",
  viewRevenueSplitTitle: "ManageRevenueSplit.ViewRevenueSplitPopupHeader",
  viewRevenueSplitMigratedTitle:
    "ManageRevenueSplit.ViewRevenueSplitMigratedPopupHeader",
  revenueSplitSectionSales: "ManageRevenueSplit.RevenueSplitSection.Sales",
  relationshipTypeList: "ManageRevenueSplit.RelationshipTypeList",
  revenueSplitSectionCounseling:
    "ManageRevenueSplit.RevenueSplitSection.Counseling",
  revenueSplitSectionAffiliateRoyalty:
    "ManageRevenueSplit.RevenueSplitSection.AffiliateRoyalty",
  revenueSplitSectionRoyaltyRetention:
    "ManageRevenueSplit.RevenueSplitSection.RoyaltyRetention",
  revenueSplitSectionTotalAmount:
    "ManageRevenueSplit.RevenueSplitSection.TotalAmount",
  revenueSplitSectionOfficeOrAffiliatesTableColumn:
    "ManageRevenueSplit.RevenueSplitSection.OfficeOrAffiliatesTableColumn",
  revenueSplitSectionSalesTableColumn:
    "ManageRevenueSplit.RevenueSplitSection.SalesTableColumn",
  revenueSplitSectionCounselingTableColumn:
    "ManageRevenueSplit.RevenueSplitSection.CounselingTableColumn",
  revenueSplitSectionAffiliateRoyaltyTableColumn:
    "ManageRevenueSplit.RevenueSplitSection.AffiliateRoyaltyTableColumn",
  revenueSplitSectionRoyaltyRetentionTableColumn:
    "ManageRevenueSplit.RevenueSplitSection.RoyaltyRetentionTableColumn",
  revenueSplitSectionTotalTableColumn:
    "ManageRevenueSplit.RevenueSplitSection.TotalTableColumn",
  revenueSplitSectionTotal: "ManageRevenueSplit.RevenueSplitSection.Total",
  revenueSplitSectionCounselingAmount:
    "ManageRevenueSplit.RevenueSplitSection.CounselingAmount",
  revenueSplitSectionCounselingAmountPopUpErrorMessage:
    "ManageRevenueSplit.RevenueSplitSection.CounselingAmountPopUpErrorMessage",
  counsellingFeeValidationMessage:
    "ManageRevenueSplit.CounsellingFeeValidationMessage",
  positiveValuesMessage:
    "ManageRevenueSplit.PositiveValuesUpTo2DecimalPlacesSupportedMessage",
};

export const downloadProformaInvoiceSiteCoreKeys = {
  downloadProformaInvoice:
    "ProgramsAndCandidates.CreateProgramComponent.FeesAndExpenses.RaiseInvoice.DownloadProformaInvoice",
  purchaseOrderEmail: "RaiseInvoice.DownloadProformaInvoice.PurchaseOrderEmail",
  emailTo: "RaiseInvoice.DownloadProformaInvoice.EmailTo",
  date: "RaiseInvoice.DownloadProformaInvoice.Date",
  participant: "RaiseInvoice.DownloadProformaInvoice.Participant",
  program: "RaiseInvoice.DownloadProformaInvoice.Program",
  feeDetailsAndAmount:
    "RaiseInvoice.DownloadProformaInvoice.FeeDetailsAndAmount",
  feeOrExpenseCategoryColumn:
    "RaiseInvoice.DownloadProformaInvoice.FeeDetailsAndAmount.FeeOrExpenseCategoryColumn",
  expenseOrFeeNameColumn:
    "RaiseInvoice.DownloadProformaInvoice.FeeDetailsAndAmount.ExpenseOrFeeNameColumn",
  expenseCategoryColumn:
    "RaiseInvoice.DownloadProformaInvoice.FeeDetailsAndAmount.ExpenseCategoryColumn",
  feeOrExpenseTypeColumn:
    "RaiseInvoice.DownloadProformaInvoice.FeeDetailsAndAmount.FeeOrExpenseTypeColumn",
  taxColumn:
    "RaiseInvoice.DownloadProformaInvoice.FeeDetailsAndAmount.TaxColumn",
  finalLineItemValueColumn:
    "RaiseInvoice.DownloadProformaInvoice.FeeDetailsAndAmount.FinalLineItemValueColumn",
  totalAmountColumn:
    "RaiseInvoice.DownloadProformaInvoice.FeeDetailsAndAmount.TotalAmountColumn",
  paymentTerms: "RaiseInvoice.DownloadProformaInvoice.PaymentTerms",
  billingOfficeAddress:
    "RaiseInvoice.DownloadProformaInvoice.BillingOfficeAddress",
  PrivateAndConfidential:
    "RaiseInvoice.DownloadProformaInvoice.PrivateAndConfidential",
  Quote: "RaiseInvoice.DownloadProformaInvoice.Quote",
  PDFLogo: "RaiseInvoice.DownloadProformaInvoice.PDFLogo",
  mediumImg: "MediumImage",
};

export const salesCreditSiteCoreKeys = {
  salesCredit: "ProgramsAndCandidates.CreateProgramComponent.SalesCredit",
  addClientRelationshipOwnerSubHeading:
    "CreateProgramComponent.SalesCredit.AddClientRelationshipOwnerSubHeading",
  clientRelationshipOwnerDropDown:
    "CreateProgramComponent.SalesCredit.ClientRelationshipOwnerDropDown",
  office: "CreateProgramComponent.SalesCredit.Office",
  percentageDropDown: "CreateProgramComponent.SalesCredit.PercentageDropDown",
  totalPercentage: "CreateProgramComponent.SalesCredit.TotalPercentage",
  clientRelationshipOwnerTableColumn:
    "CreateProgramComponent.SalesCredit.ClientRelationshipOwnerTableColumn",
  officeTableColumn: "CreateProgramComponent.SalesCredit.OfficeTableColumn",
  percentageTableColumn:
    "CreateProgramComponent.SalesCredit.PercentageTableColumn",
  actionTableColumn: "CreateProgramComponent.SalesCredit.ActionTableColumn",
  areYouSureYouWantToDeleteThisClientRelationshipOwner:
    "CreateProgramComponent.SalesCredit.AreYouSureYouWantToDeleteThisClientRelationshipOwner",
  noClientRelationshipOwnersAvailablePleaseAddThemManually:
    "CreateProgramComponent.SalesCredit.NoClientRelationshipOwnersAvailablePleaseAddThemManually",
  totalPercentageOfTheSalesCreditAssignedMustBeEqualTo100:
    "CreateProgramComponent.SalesCredit.TotalPercentageOfTheSalesCreditAssignedMustBeEqualTo100",
  minimumOfOneClientRelationshipOwnerMustBeAssignedToSalesCredit:
    "CreateProgramComponent.SalesCredit.MinimumOfOneClientRelationshipOwnerMustBeAssignedToSalesCredit",
};

export const programDocumentsTabSiteCoreKeys = {
  documentsTitle: "ProgramsAndCandidates.DocumentsTab.Documents",
  actionTableColumn: "DocumentsTab.Documents.ActionTableColumn",
  descriptionTableColumn: "DocumentsTab.Documents.DescriptionTableColumn",
  documentNameTableColumn: "DocumentsTab.Documents.DocumentNameTableColumn",
  noDocumentsAvailableMessage:
    "DocumentsTab.Documents.NoDocumentsAvailableMessage",
  typeTableColumn: "DocumentsTab.Documents.TypeTableColumn",
  uploadedByTableColumn: "DocumentsTab.Documents.UploadedByTableColumn",
  uploadedDateTableColumn: "DocumentsTab.Documents.UploadedDateTableColumn",
  uploadedNewDocumentsHyperLinkLabel:
    "DocumentsTab.Documents.UploadedNewDocumentsHyperLinkLabel",
  programDocumentTypeList: "DocumentsTab.Documents.ProgramDocumentTypeList",
  deleteDocumentConfirmationMessage:
    "DocumentsTab.Documents.DeleteDocumentConfirmationMessage",
  documentDeleted: "DocumentsTab.Documents.DocumentDeleted",
} as const;

export const programUploadNewDocumentSitecoreKeys = {
  uploadNewDocumentTitle:
    "ProgramsAndCandidates.DocumentsTab.UploadNewDocument",
  maximumFileSizeAndType:
    "DocumentsTab.UploadNewDocument.MaximumFileSizeandType",
  attachmentSection: "DocumentsTab.UploadNewDocument.AttachmentSection",
  uploadDocument: "DocumentsTab.UploadNewDocument.UploadDocument",
  description: "DocumentsTab.UploadNewDocument.Description",
  documentDetailsSection:
    "DocumentsTab.UploadNewDocument.DocumentDetailsSection",
  type: "DocumentsTab.UploadNewDocument.Type",
  uploadDate: "DocumentsTab.UploadNewDocument.UploadDate",
  uploadedBy: "DocumentsTab.UploadNewDocument.UploadedBy",
  documentUploadedToastMessage:
    "DocumentsTab.UploadNewDocument.DocumentUploadedToastMessage",
  viewDocumentNamePopupHeader:
    "DocumentsTab.UploadNewDocument.ViewDocumentNamePopupHeader",
  programDocumentTypeList:
    "DocumentsTab.UploadNewDocument.ProgramDocumentTypeList",
  maxFileSizeErrorMessage:
    "DocumentsTab.UploadNewDocument.MaxFileSizeErrorMessage",
  fileFormatErrorMessage:
    "DocumentsTab.UploadNewDocument.FileFormatErrorMessage",
} as const;
